// extracted by mini-css-extract-plugin
export default {"title":"c_d","chart-navigation":"c_f","chart-navigation__left":"c_g","chart-navigation__right":"c_h"};